export default __webpack_public_path__ + "static/media/Ritvik Sharma.bf48979b.jpg";